// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1905":"css/app.6788","5605":"css/admin-app.6788"}[chunkId] + ".css";
};